// Values match the backend TurnTimeSlaUnit enum serialized by System.Text.Json
// (PascalCase string), i.e. the `unit` field on TurnTimeMetricModel.
export const TurnTimeSlaUnit = {
  HOURS: 'Hours',
  DAYS: 'Days',
};

export const TurnTimeSlaUnitSuffix = {
  [TurnTimeSlaUnit.HOURS]: 'h',
  [TurnTimeSlaUnit.DAYS]: 'd',
};

export const VsSlaStatus = {
  AHEAD: 'AHEAD',
  ON_TARGET: 'ON_TARGET',
  BEHIND: 'BEHIND',
};

export const TRAILING_WINDOW_LABEL = 'Trailing 90 days';

export const TURN_TIME_LOW_SAMPLE_N = 5;

export const TURN_TIME_ESTIMATE_DISCLAIMER = 'Estimate, not a commitment.';

export const TURN_TIME_EMPTY_STATE_TEXT = 'No turn-time metrics defined';

export const TURN_TIME_EMPTY_STATE_DETAIL = 'Define them in Admin → Turn-Time Definitions';

export const TURN_TIME_EMPTY_STATE_LINK_LABEL = 'Open Turn-Time Definitions';

// vs-SLA status reported by the compute endpoint (TurnTimeMetricModel). WITHIN
// resolves to AHEAD or ON_TARGET by comparing the real median against the target;
// AT_RISK / BREACHED map to BEHIND; NO_SLA / INSUFFICIENT_DATA drop the metric.
// Values match the backend TurnTimeVsSlaStatus enum serialized by
// System.Text.Json (PascalCase string), i.e. the wire `vsSlaStatus` value.
export const BackendVsSlaStatus = {
  NO_SLA: 'NoSla',
  WITHIN: 'Within',
  AT_RISK: 'AtRisk',
  BREACHED: 'Breached',
  INSUFFICIENT_DATA: 'InsufficientData',
};
